import Controller from "csi/action/Controller";
import declare from "dojo/_base/declare";
import NotifyCollaboratorsStore from "./NotifyCollaboratorsStore";
import { createNotifyCollaboratorsStore } from "./NotifyCollaboratorsService";

const NotifyCollaboratorsController = declare(Controller, {

	/** @override use store instead of actioncontroller */
	async onReactViewProps(props) {
		const { m_writer } = this;
		const bom = this.getNode();
		const latestRevisionNode = this.m_cache.getNode(bom.LatestRevision);
		props.store = await createNotifyCollaboratorsStore(m_writer, latestRevisionNode, props.onSave);
	},
});
export = NotifyCollaboratorsController;